<div class="row">
  <div class="col-12 card-aling">
    <!-- <div class="mt-5"></div> -->

    <mat-card class="col-12">
      <div class="row">
        <div class="col">
          <h3>Tecidos</h3>
        </div>

        <div class="col" style="text-align: end">
          <button mat-mini-fab class="btn" color="warn" (click)="closeModal()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <!-- <mat-form-field class="mt-2">
                <mat-label>Pesquisar</mat-label>
                <input #input matInput placeholder="Pesquisar por nome" appearance="outline">
            </mat-form-field> -->

      <div class="row mt-4">
        <div class="col-sm pl-2">
          <mat-form-field>
            <input
              #input
              matInput
              placeholder="Pesquisar por Grupo, Nome e Sítio"
              [value]="store.pageSearch"
            />
          </mat-form-field>
        </div>
      </div>

      <mat-card-content>
        <mat-list role="list" class="card-list" *ngIf="store.tecidos">
          <div class="row">
            <!-- <strong class="col-4">Código</strong> -->
            <strong class="col-3">Grupo</strong>
            <strong class="col-3 text-center">Sítio</strong>
            <strong class="col-3 text-center">Tecido</strong>
          </div>

          <mat-dialog-content
            class="d-flex pl-2"
            *ngFor="let tecido of store.tecidos"
          >
            <div class="mr-auto mt-1 col-3">
              <p class="mt-4 mb-4">{{ !store.tecidos ? "" : tecido.grupo }}</p>
            </div>
            <div class="mr-auto mt-1 col-3 text-center ml-2">
              <p class="mt-4 mb-4">{{ !store.tecidos ? "" : tecido.sitio }}</p>
            </div>
            <div class="mr-auto mt-1 col-3 text-center ml-1">
              <p class="mt-4 mb-4">{{ !store.tecidos ? "" : tecido.nome }}</p>
            </div>
            <div class="mt-3 col-3 text-right">
              <button
                type="submit"
                mat-mini-fab
                style="background-color: green"
                (click)="adicionarTecido(tecido)"
              >
                <mat-icon>add</mat-icon>
              </button>
            </div>
            <mat-divider></mat-divider>
          </mat-dialog-content>
        </mat-list>

        <mat-divider></mat-divider>
      </mat-card-content>
    </mat-card>
  </div>
</div>
